import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { STORE_PATH, bannerKindOf } from '../../lib/access';
import { useAccess } from './use-access';

/**
 * "Dock" strip for self-learning students, rendered as the FIRST element of
 * the page content column (above the greeting), never outside the navbar.
 *
 * - trial running → soft blush tone, "Teste grátis · N dias", ghost button;
 * - trial over / nothing paid → dark ink dock, "Acesso pausado", white pill.
 *
 * Nothing for group / private / b2b students. The "where you stopped" line is
 * the generic sentence: resolving the exact class would cost a wall query on
 * every page.
 */
export function AccessBanner() {
  const { t } = useTranslation('p2e');
  const { data } = useAccess();
  const kind = bannerKindOf(data);
  if (kind === 'none') return null;

  const trial = kind === 'trial';
  const daysLeft = data?.base.daysLeft ?? 0;

  return (
    <div
      role="status"
      data-testid={trial ? 'access-banner-trial' : 'access-banner-limited'}
      className={
        trial
          ? 'mb-5 flex flex-col gap-3 rounded-[14px] border border-rose-100 bg-[#FDF0ED] px-4 py-3 sm:flex-row sm:items-center'
          : 'mb-5 flex flex-col gap-3 rounded-[14px] bg-[#1A1018] px-4 py-3 text-white shadow-[0_12px_30px_rgba(45,26,31,0.3)] sm:flex-row sm:items-center'
      }
    >
      <div className="min-w-0 flex-1">
        <span
          className={`block font-['Oswald'] text-[10px] font-semibold uppercase tracking-[0.18em] ${
            trial ? 'text-[#D41920]' : 'text-[#F2A0C4]'
          }`}
        >
          {trial ? t('access.banner.trialEyebrow', { count: daysLeft }) : t('access.banner.limitedEyebrow')}
        </span>
        <span className={`block text-sm ${trial ? 'text-[#2D1A1F]' : 'text-white'}`}>
          {trial ? t('access.banner.trialText') : t('access.banner.limitedText')}
        </span>
      </div>
      <Link
        to={STORE_PATH}
        className={
          trial
            ? "inline-flex w-full items-center justify-center rounded-full border border-dashed border-[#F2A0C4] px-4 py-2 font-['Oswald'] text-[11px] font-bold uppercase tracking-[0.08em] text-[#D41920] hover:bg-white sm:w-auto"
            : "inline-flex w-full items-center justify-center rounded-full bg-white px-4 py-2 font-['Oswald'] text-[11px] font-bold uppercase tracking-[0.08em] text-[#D41920] hover:bg-rose-50 sm:w-auto"
        }
      >
        {t('access.banner.subscribe')}
      </Link>
    </div>
  );
}
